import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";

// Authentication
import LoginReducer from "./auth/login/reducer";

// Advacne Payment Offer
import CunsumerOfferReducer from "../slices/cunsumerOffer/reducer"

//
import dashboardReducer from './dashboard/dashboardSlice'

//secr
import authReducer from "./authSlice/authSlice"

// AdminData
import adminReducer from "./admin/storeSlice"
import interStoreProductReducer from './authSlice/interStoreProductSlice'
const rootReducer = combineReducers({
    Layout: LayoutReducer,
    Login: LoginReducer,
    CunsumerOfferId: CunsumerOfferReducer,
    dashboard: dashboardReducer,
    authData: authReducer,
    adminAction: adminReducer,
    interStoreProduct: interStoreProductReducer,
});

export default rootReducer;